import IntranetLayout from "@/components/IntranetLayout";
import CommercialValueCenterBody from "@/pages/shared/CommercialValueCenterBody";

const EmployeeCommercialValueCenter = () => (
  <IntranetLayout>
    <CommercialValueCenterBody editable={true} />
  </IntranetLayout>
);

export default EmployeeCommercialValueCenter;
